import { Button } from '@/components/ui/button'
import { useNavigate } from 'react-router-dom'
import { useMediaQueryLG } from '@/hooks/useMediaquery'

export default function PasswordChanged() {
  const navigate = useNavigate()
  const isMobile = useMediaQueryLG()

  return (
    <main className="w-full" aria-label="Password changed confirmation page">
      <header className="flex flex-col items-center lg:items-start gap-4 sm:gap-6 w-full">
        <img
          src="/auth/success-illustration.svg"
          alt="SlopeSync logo"
          className="w-28 sm:w-48"
        />
        <div className="flex flex-col items-center lg:items-start gap-2 sm:gap-3 w-full">
          <div className="text-center lg:text-left">
            <h1 className="text-xl lg:text-ss-lg leading-7 lg:leading-11 font-bold text-ss-gray-950 max-w-xl uppercase font-[ClashDisplay]">
              PASSWORD CHANGED
            </h1>
            <h1 className="text-xl lg:text-ss-lg leading-7 lg:leading-11 font-bold text-ss-blue-500 max-w-xl uppercase font-[ClashDisplay]">
              SUCCESSFULLY
            </h1>
          </div>
          <p className="text-sm lg:text-base font-semibold text-ss-gray-600 max-w-md text-center lg:text-left">
            Always remember the password for your account at Learner!
          </p>
        </div>
      </header>
      <Button
        size={isMobile ? 'small' : 'large'}
        type="submit"
        className="w-full"
        onClick={() => navigate('/auth/login')}
        aria-label="Back to Log In"
      >
        Back to Log In
      </Button>
    </main>
  )
}
